/**
 * French translations for KaraoNow SuperAdmin
 */
export default {
  common: {
    email: 'E-mail',
    password: 'Mot de passe',
    logout: 'Déconnexion',
    login: 'Connexion',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    name: 'Nom',
    status: 'Statut',
    actions: 'Actions',
    noData: 'Aucune donnée disponible',
    active: 'Actif',
    suspended: 'Suspendu',
    confirmAction: 'Êtes-vous sûr ?',
    joinedDate: 'Date d\'adhésion',
    firstName: 'Prénom',
    lastName: 'Nom',
    pseudo: 'Pseudo',
    save: 'Enregistrer',
    cancel: 'Annuler',
    settings: 'Paramètres',
    backHome: 'Retour à l\'accueil',
    all: 'Tous',
    search: 'Rechercher',
    restore: 'Restaurer',
    delete: 'Supprimer',
  },
  auth: {
    login: 'Se connecter',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    resetPasswordDescription: 'Entrez votre nouveau mot de passe ci-dessous',
    resetPasswordButton: 'Réinitialiser le mot de passe',
    passwordResetSuccess: 'Mot de passe réinitialisé',
    passwordResetSuccessDescription: 'Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé vers la connexion.',
    resetLinkExpired: 'Lien de réinitialisation expiré',
    resetLinkExpiredDescription: 'Le lien de réinitialisation a expiré. Veuillez demander un nouveau lien.',
    requestNewResetLink: 'Demander un nouveau lien',
    backToLogin: 'Retour à la connexion',
    rememberPassword: 'Vous vous souvenez de votre mot de passe ?',
    passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.',
    error: {
      notSuperadmin: 'Accès non autorisé',
      invalidCredentials: 'Identifiants invalides',
    },
  },
  email: {
    success: 'E-mail confirmé',
    confirmationFailed: 'Échec de la confirmation de l\'e-mail',
    verifyingDescription: 'Vérification de votre e-mail...',
    confirmationSuccess: 'Votre e-mail a été confirmé avec succès',
    newEmailAddress: 'Nouvelle adresse e-mail',
    redirectingToLogin: 'Redirection vers la connexion...',
  },
  errors: {
    required: 'Ce champ est requis',
    passwordRequirements: 'Le mot de passe ne respecte pas les critères de sécurité',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    invalidToken: 'Token invalide',
    resetPasswordFailed: 'Impossible de réinitialiser le mot de passe',
  },
  superadmin: {
    title: 'SuperAdmin',
    dashboard: 'Tableau de bord',
    dashboardDesc: 'Vue d\'ensemble de votre plateforme KaraoNow',
    totalOrganizers: 'Organisateurs',
    totalSingers: 'Chanteurs',
    totalEvents: 'Événements',
    totalRevenue: 'Revenus',
    quickActions: 'Actions rapides',
    manageOrganizers: 'Gérer les organisateurs',
    manageSingers: 'Gérer les chanteurs',
    viewReports: 'Voir les rapports',
    organizers: 'Organisateurs',
    singers: 'Chanteurs',
    company: 'Entreprise',
    events: 'Événements',
    eventsJoined: 'Événements rejoints',
    suspend: 'Suspendre',
    loginInfo: 'Utilisez vos identifiants de superadmin pour accéder au panneau d\'administration.',
    settings: 'Paramètres',
    editProfile: 'Modifier le profil',
    profileDescription: 'Gérez vos informations personnelles',
    changePassword: 'Modifier le mot de passe',
    passwordDescription: 'Sécurisez votre compte en changeant votre mot de passe. Un email de réinitialisation sera envoyé à votre adresse.',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    saveChanges: 'Enregistrer les modifications',
    passwordUpdated: 'Email de réinitialisation envoyé avec succès',
    profileUpdated: 'Profil mis à jour avec succès',
    pendingEmail: 'E-mail en attente de confirmation',
    emailChangeConfirm: 'Un email de confirmation a été envoyé à votre nouvelle adresse e-mail.',
  },
}
